import React from "react";
import { WarningAmber } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import useArchitectureSupport from "fond/architecture/useArchitectureSupport";
import { ArchitectureBase, Maybe } from "fond/types";

const tooltipMessage = (hasDemandModel: boolean, hasBomCosts: boolean): string => {
  let message;
  if (!hasDemandModel && !hasBomCosts) {
    message = "a Demand Model and BOM costs";
  } else if (!hasDemandModel) {
    message = "a Demand Model";
  } else if (!hasBomCosts) {
    message = "BOM costs";
  } else {
    throw new Error("tooltipMessage should not be called when both demand model and BOM costs are present.");
  }

  return `This architecture is missing ${message}. Advanced analysis will not be available while using this architecture.`;
};

interface OldArchitectureWarningProps {
  architecture: Maybe<ArchitectureBase>;
}

const OldArchitectureWarning: React.FC<OldArchitectureWarningProps> = ({ architecture }) => {
  const { hasDemandModel, hasBomCosts } = useArchitectureSupport(architecture);
  if (!architecture || (hasDemandModel && hasBomCosts)) return null;

  return (
    <Tooltip title={tooltipMessage(hasDemandModel, hasBomCosts)}>
      <WarningAmber color="secondary" fontSize="small" />
    </Tooltip>
  );
};

export default OldArchitectureWarning;
